export default __webpack_public_path__ + "static/media/Stalker's Leggings of the Battlethrall.48937506.jpg";